<template>
  <account-order-details-grid
    :headers="tableHeaders"
    :items="tableData"
    :table-data="tableData"
    :page-size="50"
    :status="status"
    :subtotal="subtotal"
  >
  </account-order-details-grid>
</template>

<script>
export default {
  props: {
    orderData: {
      type: Object,
      required: true,
      default: () => null,
    },
    tableHeaders: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    shipment: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      status: '',
    };
  },
  computed: {
    subtotal() {
      return this.orderData ? this.orderData.subtotals[this.shipment]?.prices?.subtotal?.formattedValue : '';
    },
  },
};
</script>
